import type { FilterOption } from '@components/filters/OptionFilterPanel';

export type FilterKey = 'inviteStatus' | 'status' | 'armedPermission' | 'verified' | 'hasImage';

export type FilterState = Record<FilterKey, Record<string, boolean>>;

export const FILTER_OPTIONS: Record<FilterKey, FilterOption[]> = {
  inviteStatus: [
    { value: 'sent', name: 'Sent' },
    { value: 'unsent', name: 'Unsent' },
  ],
  status: [
    { value: 'active', name: 'Active' },
    { value: 'suspended', name: 'Suspended' },
  ],
  armedPermission: [
    { value: 'true', name: 'Yes' },
    { value: 'false', name: 'No' },
  ],
  verified: [
    { value: 'true', name: 'Yes' },
    { value: 'false', name: 'No' },
  ],
  hasImage: [
    { value: 'true', name: 'Yes' },
    { value: 'false', name: 'No' },
  ],
};

export const FILTER_LABELS: Record<FilterKey, string> = {
  inviteStatus: 'Invite Status',
  status: 'Job Status',
  armedPermission: 'Armed Permission',
  verified: 'Verified',
  hasImage: 'Has Image',
};

export const FILTER_URL_KEYS: Record<FilterKey, string> = {
  inviteStatus: 'invite_status',
  status: 'status',
  armedPermission: 'armed_permission',
  verified: 'verified',
  hasImage: 'has_image',
};

export const buildInitialFilterState = (): FilterState => ({
  inviteStatus: {},
  status: {},
  armedPermission: {},
  verified: {},
  hasImage: {},
});

export const getFilterParams = (filterState: FilterState) => ({
  inviteStatuses: Object.keys(filterState.inviteStatus),
  statuses: Object.keys(filterState.status),
  armedPermissions: Object.keys(filterState.armedPermission),
  verified: Object.keys(filterState.verified),
  hasImage: Object.keys(filterState.hasImage),
});

export const getFilterLabels = (
  filterState: FilterState
): { key: FilterKey; label: string; value: string }[] => {
  const result: { key: FilterKey; label: string; value: string }[] = [];
  for (const key of Object.keys(FILTER_OPTIONS) as FilterKey[]) {
    const selected = FILTER_OPTIONS[key]
      .filter(o => filterState[key][o.value])
      .map(o => o.name);
    if (selected.length > 0) {
      result.push({ key, label: `${FILTER_LABELS[key]}:`, value: selected.join('; ') });
    }
  }
  return result.sort((a, b) => a.label.localeCompare(b.label));
};

export const clearByKey = (prev: FilterState, key: FilterKey): FilterState => ({
  ...prev,
  [key]: {},
});
